import React, { useCallback } from 'react';
import { searchSalesforceAccounts } from '../../../api/api';
import { TheaterType } from '../../../enums';
import { SalesforceAccount } from '../../../interfaces';
import { AutoComplete, AutoCompleteItem } from './AutoComplete';

export type SalesforceAccountsAutoCompleteProps = React.HTMLProps<HTMLInputElement> & {
  defaultValue?: string;
  theater: TheaterType;
  placeholder: string;
  onAccountChange?: (account?: SalesforceAccount) => void;
  onAccountValueChange?: (value: string) => void;
};

export const SalesforceAccountsAutoComplete: React.FC<SalesforceAccountsAutoCompleteProps> = (
  props: SalesforceAccountsAutoCompleteProps
) => {
  const renderValue = useCallback((item: AutoCompleteItem) => `${item.value} : ${item.id}`, []);

  const fetchDataCallback = useCallback(
    async (keyword: string) => {
      const d = await searchSalesforceAccounts(keyword, props.theater);
      return d
        .filter((i) => i.SFAccountID !== 'NA')
        .map((i) => ({ id: i.SFAccountID, value: i.Name }));
    },
    [props.theater]
  );

  const handleSelectionChange = useCallback(
    (item: AutoCompleteItem) => {
      if (props.onAccountChange)
        props.onAccountChange(item ? { SFAccountID: item.id, Name: item.value } : undefined);
    },
    [props]
  );

  const handleInputValueChange = useCallback(
    (value: string) => {
      if (props.onAccountValueChange) props.onAccountValueChange(value);
    },
    [props]
  );

  return (
    <AutoComplete
      lazy={true}
      renderValue={renderValue}
      fetchDataCallback={fetchDataCallback}
      onSelectionChange={handleSelectionChange}
      onInputValueChange={handleInputValueChange}
      {...props}
    />
  );
};
